import { Globe } from "lucide-react";
import { DropdownMenu, DropdownMenuContent, DropdownMenuItem, DropdownMenuTrigger } from "@/components/ui/dropdown-menu";
import { LANGS } from "@/i18n/translations";
import { useLang } from "@/i18n/LanguageContext";

export const LangSwitcher = () => {
  const { lang, setLang, t } = useLang();
  return (
    <DropdownMenu modal={false}>
      <DropdownMenuTrigger
        data-testid="language-switcher"
        aria-label={t.nav.language}
        className="flex items-center gap-1.5 rounded-full border border-white/15 px-3 py-2 font-mono text-xs uppercase tracking-widest text-slate-200 hover:border-violet-400/60 hover:text-white transition-colors"
      >
        <Globe className="w-3.5 h-3.5" /> {lang}
      </DropdownMenuTrigger>
      <DropdownMenuContent align="end" className="bg-[#0b0e26] border-white/10 text-slate-100 min-w-[160px]">
        {LANGS.map((l) => (
          <DropdownMenuItem
            key={l.code}
            data-testid={`language-option-${l.code}`}
            onClick={() => setLang(l.code)}
            className={`cursor-pointer focus:bg-violet-500/20 focus:text-white ${lang === l.code ? "text-sky-300" : ""}`}
          >
            <span className="font-mono text-xs w-7 opacity-70">{l.short}</span> {l.label}
          </DropdownMenuItem>
        ))}
      </DropdownMenuContent>
    </DropdownMenu>
  );
};
